// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1if6Y","upload":"Small_upload__1i2y9","imageWrap":"Small_imageWrap__1luUK","removeBtn":"Small_removeBtn__3iwbe"};